export default __webpack_public_path__ + "static/media/pause-recording.bc7cb48c.svg";